import { render, staticRenderFns } from "./scenic.vue?vue&type=template&id=6b72e5f7&scoped=true"
import script from "./scenic.vue?vue&type=script&lang=js"
export * from "./scenic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72e5f7",
  null
  
)

export default component.exports